import React from 'react';

import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import { Divider, Skeleton, Typography } from '@mui/material';
import classNames from 'classnames';

import { AppServicesContext } from '@kamernet/core/AppServices';
import { reportError } from '@kamernet/core/Errors';
import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { useListingSelectors } from '@kamernet/modules/Listing/context/hooks/useListingSelectors';
import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';

import styles from './NumberOfSearchers.module.css';

export const NumberOfSearchers: React.FC = () => {
  const [activeTenantsCount, setActiveTenantsCount] = React.useState<number>(0);
  const isLoading = useListingSelectors().isLoading();
  const { listingsState } = ListingsContext.useContext();
  const cityName = listingsState.filterResult.filters.location?.cityName;
  const { T } = useIntl();
  const isMobile = !useMediaIsDesktop();
  const { apiClient } = AppServicesContext.useContext();

  React.useEffect(() => {
    async function fetchActiveTenants() {
      if (cityName && cityName.toLowerCase() !== 'netherlands') {
        const response = await apiClient.other.activeTenantCount(cityName);
        setActiveTenantsCount(response.data);
      } else {
        setActiveTenantsCount(0);
      }
    }

    fetchActiveTenants().catch((error: Error) => {
      setActiveTenantsCount(0);
      reportError(
        new Error('Active tenant count operation failed - Listing search'),
        {
          extra: {
            cause: { error },
          },
        },
      );
    });
  }, [apiClient.other, cityName]);

  return (
    <div className={styles.root}>
      {isLoading ? (
        <Skeleton
          className={classNames(
            CommonStyles.margin_top_1,
            CommonStyles.margin_bottom_2,
          )}
          variant="text"
          height={20}
          width="80%"
        />
      ) : (
        activeTenantsCount > 0 &&
        cityName && (
          <React.Fragment>
            <ScreenSearchDesktopIcon className={styles.icon} />

            <Typography
              variant={isMobile ? 'body4' : 'body3'}
              dangerouslySetInnerHTML={{
                __html: T(
                  'LBL_SEARCH_URGENCY_MESSAGE',
                  activeTenantsCount,
                  cityName || T('LBL_NETHERLANDS'),
                ),
              }}
            />
          </React.Fragment>
        )
      )}
      <Divider className={styles.divider} variant="fullWidth" />
    </div>
  );
};
